<div
  #panel
  class="zoom-panel-display mat-elevation-z8"
  [style.overflow]="'hidden'"
  tabindex="1"
  (keydown)="onKeyboardEvent($event)"
  (keyup)="onKeyboardEvent($event)"
  (focusout)="handleFocusOut()"
  (focusin)="handleFocusIn()"
  h3ScrollDisabler
>
  <h3-layers
    [primaryOutputInjector]="primaryOutputInjector"
    [calibrationData]="calibrationData$ | async"
    [isInsideZoomPanel]="true"
  ></h3-layers>
</div>
<span class="zoom-panel-hint">Scroll to adjust</span>
<h3-zoom-panel-cursor></h3-zoom-panel-cursor>
